//

export default {
  name:'AccountIndex',
  beforeCreate () {
    // force redirect if user enter /account route
    return this.$router.push('/account/dashboard')
  }
}
